interface CustomerChipProps {
  name: string
  short: string
  color: string
  size?: 'sm' | 'md'
}

export function CustomerChip({ name, short, color, size = 'sm' }: CustomerChipProps) {
  const dim = size === 'sm' ? 18 : 22
  return (
    <span className="row" style={{ gap: 7 }}>
      <span style={{
        width: dim, height: dim, borderRadius: 4,
        background: color, color: 'white',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 9.5, fontWeight: 700, fontFamily: 'JetBrains Mono', letterSpacing: '-0.04em',
        flexShrink: 0,
      }}>
        {short}
      </span>
      <span style={{ fontWeight: 500 }}>{name}</span>
    </span>
  )
}
